import { Link } from "react-router-dom";
import LegalDocumentPage from "../components/LegalDocumentPage";
import { LEGAL_OPERATOR, LEGAL_PUBLIC_LINKS } from "../content/legalMeta";
import { OFERTA_SECTIONS } from "../content/ofertaContent";
import "../pages/app-workspace.css";

export default function Oferta() {
  return (
    <LegalDocumentPage
      standalone
      title="Публичная оферта"
      subtitle="Договор на оказание цифровых услуг платформы MOGAME"
      heroLead={
        <>
          Настоящая оферта является официальным предложением заключить договор
          на оказание услуг на условиях, изложенных ниже. Документ дополняет
          Правила сервиса и{" "}
          <Link to="/politic-confidencial">Политику конфиденциальности</Link>.
        </>
      }
      sections={OFERTA_SECTIONS}
      footerLinks={LEGAL_PUBLIC_LINKS.filter((link) => link.href !== "/oferta")}
      footerNote={
        <>
          Вопросы по оплате и возвратам:{" "}
          <a href={`mailto:${LEGAL_OPERATOR.email}`}>{LEGAL_OPERATOR.email}</a>
          {" · "}
          <a
            href={LEGAL_OPERATOR.telegramUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {LEGAL_OPERATOR.telegram}
          </a>
        </>
      }
    />
  );
}
